import DeleteIcon from '@mui/icons-material/Delete';
import { Badge, Grid, IconButton, Typography } from '@mui/material';
import { Theme } from '@mui/material/styles';
import * as React from 'react';
import { makeStyles } from 'tss-react/mui';
import { removeMediaFromContactComposeMessage } from '../../../../../store/conversation';
import { useAppDispatch } from '../../../../../store/hooks';

interface Props {
    contactId: number;
    file: string;
}

export function MediaItem({ contactId, file }: Props) {
    const { classes } = useStyles();
    const dispatch = useAppDispatch();

    const [showDelete, setShowDelete] = React.useState<boolean>(false);

    const handleMouseEnter = () => {
        setShowDelete(true);
    };

    const handleMouseLeave = () => {
        setShowDelete(false);
    };

    const handleDelete = () => {
        // delete the media from the contact
        dispatch(removeMediaFromContactComposeMessage({ contactId, media: file }));
    };

    const fileExtension = React.useMemo(
        () => file.substring(file.lastIndexOf('.'), file.length) || file,
        [file],
    );

    return (
        <Grid
            item
            className={classes.container}
            component="div"
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
            onClick={handleDelete}
        >
            <Badge
                badgeContent={
                    showDelete && (
                        <IconButton aria-label="delete" color="error">
                            <DeleteIcon />
                        </IconButton>
                    )
                }
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
            >
                {fileExtension === '.jpg' ||
                fileExtension === '.webp' ||
                fileExtension === '.png' ||
                fileExtension === '.gif' ? (
                    <img
                        src={file}
                        alt={`Media from contact ${contactId}`}
                        className={classes.img}
                    />
                ) : (
                    <Typography variant="body1" display="block" whiteSpace="pre-wrap" p={2}>
                        {fileExtension}
                    </Typography>
                )}
            </Badge>
        </Grid>
    );
}

const useStyles = makeStyles()((theme: Theme) => ({
    container: {
        '&:hover': {
            cursor: 'pointer',
            opacity: 0.7,
        },
    },
    img: {
        maxWidth: '100px',
        maxHeight: '100px',
        display: 'flex',
        border: '1px solid #ccc',
        borderRadius: '10px',
    },
}));
